export enum HealthInsuranceType {
  HEALTH_BASIS = "healthBasis",
  HEALTH_PLUS = "healthPlus",
  HEALTH_TOP = "healthTop",
}
